import { initializeApp, FirebaseApp } from "firebase/app";
import { getMessaging, getToken, onMessage, Messaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

let app: FirebaseApp | undefined;
let messaging: Messaging | undefined;

// Evita crash de tela branca se as variáveis .env não estiverem setadas
if (process.env.REACT_APP_FIREBASE_API_KEY) {
  try {
    app = initializeApp(firebaseConfig);
    messaging = getMessaging(app);
  } catch (err) {
    console.error("Firebase initialization error", err);
  }
}

export const requestFirebaseNotificationPermission = async () => {
  try {
    if (!messaging) return null;

    // Garante que o Service Worker compatível está registrado
    let registration;
    try {
      registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
      console.log('Service Worker registrado com sucesso no Firebase:', registration);
    } catch (swError) {
      console.warn("Falha ao registrar Service Worker manualmente, prosseguindo com o default", swError);
    }

    let permission = Notification.permission;
    if (permission !== "granted") {
      permission = await Notification.requestPermission();
    }
    
    if (permission === "granted") {
      const tokenOptions: any = {
        vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY
      };
      
      // Se tivermos o registro manual, forçamos o firebase a usar ele para interceptar
      if (registration) {
        tokenOptions.serviceWorkerRegistration = registration;
      }

      const token = await getToken(messaging, tokenOptions);
      return token;
    } else {
      console.warn("Notification permission denied");
      return null;
    }
  } catch (error) {
    console.error("An error occurred while requesting notification permission:", error);
    return null;
  }
};

export const onMessageListener = () =>
  new Promise((resolve) => {
    if (!messaging) return;
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });

export { messaging };
